import { StyleSheet } from 'react-native'

const buttonText = {
  fontFamily: "Montserrat-BlackItalic",
  fontSize: 16,
}

export default StyleSheet.create({
  containerButton: {
    position: 'absolute',
    width: '100%',
    bottom: 0
  },
  button: {
    height: 50,
    backgroundColor: '#ff0000',
    alignItems: 'center',
    justifyContent: 'center'
  },
  buttonDisabled: {
    height: 50,
    backgroundColor: '#99000055',
    alignItems: 'center',
    justifyContent: 'center'
  },
  buttonText: {
    ...buttonText,
    color: '#fff'
  },
  buttonTextDisabled: {
    ...buttonText,
    color: '#999'
  },
})
